/*!
* name ZJX 教学资源
* Copyright 2018-2019
*/
<template>
  <div v-show="showColumn">
    <publicNav></publicNav>

    <div class="submit_box" v-if="isHide == 1">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label>
          <el-select v-model="formInline.region1" placeholder="请选择" clearable>
            <el-option label="其他老师上传" value="other"></el-option>
            <el-option label="本人上传" value="myself"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="formInline.region2" placeholder="请选择" clearable>
            <el-option label="未分享" value="0"></el-option>
            <el-option label="已分享" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <template>
      <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="title" label="资源标题" width="150"></el-table-column>
        <el-table-column prop="attachments" label="附件" width="160">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.attachments" :key="index">
              <div v-if="item.file_name.substring(item.file_name.length-3) == 'jpg'">
                {{item.file_name}}
              </div>
              <div v-if="item.file_name.substring(item.file_name.length-3) == 'zip'">
                {{item.file_name}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="author" label="上传者" width="100">
          <template slot-scope="scope">
            <span>{{(scope.row.author && scope.row.author.name) ? scope.row.author.name : scope.row.author ? scope.row.author: '乐画网'}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="typeId==1" prop="is_shared" label="分享状态">
          <template slot-scope="scope" v-if="typeId==1">
            <span>{{scope.row.is_shared == 0 ? '未分享' : '已分享'}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="typeId==1" prop="stateName" label="审核状态"></el-table-column>
        <el-table-column prop="thumb_up_num" label="点赞数" width="80"></el-table-column>
        <el-table-column prop="download_num" label="下载数" width="80"></el-table-column>
        <el-table-column prop="created_at" label="上传时间" width="100"></el-table-column>
        <el-table-column v-if="typeId==1" prop="operator.name" label="发送老师" width="100"></el-table-column>
        <el-table-column prop="btn" label width="100">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="totalData"
        @current-change="pageNumberChange"
      ></el-pagination>
    </template>
  </div>
</template>

<script>
import publicNav from '@/components/publicnav' //引入公共页签
import cacheUtils from '@/common/cacheUtils' //调用缓存
import apiInterface from '@/api/index' //接口
export default {
  data () {
    return {
      // 查询
      formInline: {
        region1: '',
        region2: ''
      },
      // 表格数据
      tableData: [],
      totalData: 0, // 数据总数
      pageSize: 10, // 每页条数
      studentId: '', // 学生ID
      typeId: 1,
      isHide: cacheUtils.sessionStorage('status').get('zjx'),
      showColumn: false
    }
  },
  computed: {},
  components: {
    publicNav
  },
  mounted () {
    this.getChingResourceslist()
  },
  methods: {
    // 查询
    onSubmit () {
      this.getChingResourceslist()
    },
    formatter (row) {
      return row.address
    },
    handleEdit (index, row) {
      this.$router.push({
        path: '/resourcedetails',
        query: {
          id: row.id,
          source: 'jxzy'
        }
      })
    },
    // 分页页码改变
    pageNumberChange (pageNumber) {
      this.getChingResourceslist(pageNumber)
    },
    // 获取作品集列表
    async getChingResourceslist (pages = 1) {
      let data = { page: pages }
      if (this.formInline.region2) {
        data.is_shared = this.formInline.region2
      }
      if (this.formInline.region1) {
        data.author_type = this.formInline.region1
      }
      try {
        let pdata = await this.$xhr.get(
          cacheUtils.sessionStorage('status').get('zjx') == '1'
            ? apiInterface.resources
            : apiInterface.myStudentsDownloaded,
          {
            params: data
          }
        )
        // let tableData = pdata.data.filter(_o => {
        //   return _o.user_id === this.studentId
        // })
        this.tableData = pdata.data
        this.totalData = pdata.meta.pagination.total
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 获取个人信息内容
    async accessPersonalInformation () {
      try {
        let pdata = await this.$xhr.get(apiInterface.userInfo, { params: {} })
        this.typeId = pdata.data.type_id
        this.showColumn = true
        let studentObj = pdata.data.student
        if (studentObj && studentObj.user_id) {
          this.studentId = studentObj.user_id
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  },
  created () {
    this.accessPersonalInformation()
    // this.getChingResourceslist()
  },
  watch: {},
  props: {}
}
</script>

<style lang="scss">
.personal_center_menu_right .el-table .cell {
  text-align: center;
}

.el-button--mini {
  border: #15c1e4 solid 1px;
  color: #15c1e4;
}

.el-pagination {
  text-align: center;
  padding: 80px 0;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  font-weight: 100;
  color: #66686b;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #15c1e4;
}

.type_el {
  float: left;
  width: 20px;
  height: 20px;
}
</style>

